export enum PreSelectReversalResponsible {
    DonorCenter = 1,
    RecipientCenter = 2,
    NeitherSelected = 3
}